export class StringUtil {
  public static truncateWithEllipses(text: string, length: number): string {
    return text.substr(0, length) + (text.length > length ? '...' : '');
  }
}
